import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { DEFAULT_THEME_ACCENT, normalizeAccentColor } from "@/lib/theme/constants";
import { noopStorage } from "@/lib/storage/noop-storage";

export type ThemeMode = "dark" | "light";

type ThemeState = {
  theme: ThemeMode;
  accentColor: string;
  setTheme: (theme: ThemeMode) => void;
  setAccentColor: (color: string) => void;
};

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: "light",
      accentColor: DEFAULT_THEME_ACCENT,
      setTheme: (theme) => set({ theme }),
      setAccentColor: (color) =>
        set({ accentColor: normalizeAccentColor(color) ?? DEFAULT_THEME_ACCENT }),
    }),
    {
      name: "atech-theme",
      storage: createJSONStorage(() =>
        typeof window !== "undefined" ? localStorage : noopStorage,
      ),
      partialize: (state) => ({ theme: state.theme, accentColor: state.accentColor }),
    },
  ),
);
